import { ProductProposals, ProductProposalsCreate, ProductProposalsDetail } from 'src/Components/Pages/Data/ProductProposalsPages';

import { ProductProposalsXlsImport } from '@/Components/Pages/Data/ProductProposalsPages/ProductProposals/XlsImport';

import { RoutePage } from '../types';

export const ProductProposalsPage: RoutePage = {
    url: 'product-proposals',
    component: <ProductProposals />,
    sidebar: {
        name: 'Product proposals',
    },
    permissions: {
        entity: 'ProductProposals',
        right: 'read',
    },
    children: [
        {
            url: 'import-xls',
            component: <ProductProposalsXlsImport />,
        },
        {
            url: 'create',
            component: <ProductProposalsCreate />,
            permissions: {
                entity: 'ProductProposals',
                right: 'create',
            },
        },
        {
            url: ':id',
            component: <ProductProposalsDetail />,
            children: [
                {
                    url: 'edit',
                    component: <ProductProposalsCreate edit />,
                    permissions: {
                        entity: 'ProductProposals',
                        right: 'create',
                    },
                },
            ],
        },
    ],
};
